module.exports = __webpack_public_path__ + "media/additive.7bbc6dfe.svg";